import { DiffMiniLine } from "@/v2-backoffice-client/components/diff"
import {
  isRevertable,
  type PendingChangeRow,
} from "@/v2-backoffice-client/translation/pending/translation.pending.utils"

export type TranslationPendingDiffCellProps = {
  row: PendingChangeRow
}

// Compact − old / + new pair for a table cell, matching the Pending code
// sync view's mini-diff styling. Text rows show the description pair when only
// the description changed; every other facet has a single value to show.
function TranslationPendingDiffCell(props: TranslationPendingDiffCellProps) {
  const { row } = props

  const showDescription =
    row.oldName === row.newName && row.oldDescription !== row.newDescription
  const isText = isRevertable(row)
  const oldShown = isText
    ? showDescription
      ? row.oldDescription
      : row.oldName
    : row.oldValue
  const newShown = isText
    ? showDescription
      ? row.newDescription
      : row.newName
    : row.newValue

  return (
    <span className="flex min-w-0 flex-col gap-0.5">
      {row.kind !== "added" ? (
        <DiffMiniLine side="old" text={oldShown} />
      ) : null}
      {row.kind !== "removed" ? (
        <DiffMiniLine side="new" text={newShown} />
      ) : null}
    </span>
  )
}

export default TranslationPendingDiffCell
